import md5 from 'js-md5'
export default {
  install (Vue) {
    // 进入路由
    Vue.prototype.enterRouter = function enterRouter (name, query) {
      this.$router.push({ name: name, query })
    }
    Vue.prototype.formatCurrency = function formatCurrency (money) {
      if (money && money != null) {
        money = String(money)
        let left = money.split('.')[0]
        let right = money.split('.')[1]
        right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : '.00'
        let temp = left.split('').reverse().join('').match(/(\d{1,3})/g)
        return (Number(money) < 0 ? '-' : '') + temp.join(',').split('').reverse().join('') + right
      } else if (money === 0) { // 注意===在这里的使用，如果传入的money为0,if中会将其判定为boolean类型，故而要另外做===判断
        return '0.00'
      } else {
        return ''
      }
    }
    Vue.prototype.scrollTo = (element, to, duration) => {
      if (duration <= 0) return
      const difference = to - element.scrollTop
      const perTick = difference / duration * 10
      setTimeout(() => {
        element.scrollTop = element.scrollTop + perTick
        if (element.scrollTop === to) return
        scrollTo(element, to, duration - 10)
      }, 10)
    }
    // 加密传参
    Vue.prototype.jsonSort = (jsonObj) => {
      let arr = Object.keys(jsonObj).sort() // 参数进行首字母排序
      let str = ''
      let secretKey = 'yiyongok188yibaook' // 私钥
      for (var i in arr) {
        str += arr[i] + '=' + jsonObj[arr[i]] + '&'
      }
      console.log('未加密前拼接', `${str.substr(0, str.length - 1)}&secret=${secretKey}`)
      return md5(`${str.substr(0, str.length - 1)}&secret=${secretKey}`) // 进行md5加密返回
    }
    // 文件名字添加时间戳
    Vue.prototype.fileNameInit = (path, name) => {
      const nameFront = name.substring(0, name.lastIndexOf('.'))
      const nameLast = name.substring(name.lastIndexOf('.')+1)
      const timeStamp = new Date().getTime()
      const fileName = `${nameFront}${timeStamp}.${nameLast}`
      return `${path}${fileName}`
    }
    Vue.prototype.fileNameUpdate = (name) => {
      const beforeNameFront = name.substring(name.lastIndexOf('/') + 1) // 去掉文件路径之后的文件名
      const str = beforeNameFront.substring(0, beforeNameFront.lastIndexOf('.')) // 去掉后缀名之后的
      const afterInterception = str.slice(0, -13) // 截取后面13时间戳之后的
      const nameLast = name.substring(name.lastIndexOf('.') + 1) // 文件后缀名
      return `${afterInterception}.${nameLast}`
    }
    Vue.prototype.decodeFileName = (name) => {

      return name.substring(name.lastIndexOf('/') + 1) // 去掉文件路径之后的文件名
    }
    // 时间格式化
    Vue.prototype.timeFormat = (time) => {
      let year = time.getFullYear()
      let month = time.getMonth() + 1
      let day = time.getDate()
      let hour = time.getHours()
      let minute = time.getMinutes()
      if (month >= 1 && month <= 9) { month = `0${month}` }
      if (day >= 1 && day <= 9) { day = `0${day}` }
      if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
      if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
      return `${year}.${month}.${day} ${hour}:${minute}`
    }
  }
}
